<template>
  <header>
  	<nav v-if="pc" class="primary_navi">
      <div class="head">ドローンに関する全てのサービス</div>
      <ul class="links">
        <li class="link"><a href="https://droneagent.jp/" target="blank">ドローン専用EC</a></li>
        <li class="link"><a href="https://droneagent.jp/kusatsu" target="blank">空 撮</a></li>
        <li class="link"><a href="https://dronecamp.jp/" target="blank">教 習</a></li>
        <li class="link"><a href="https://droneagent.jp/flights" target="blank">ドローンメディア</a></li>
        <li class="link"><a href="https://care.droneagent.jp/" target="blank">ケア・保守</a></li>
        <li class="link"><a href="https://droneagent.jp/law/" target="blank">許可申請代行</a></li>
        <li v-if="clogin" class="link member"><router-link :to="'/signup'">新規登録</router-link></li>
        <li v-if="clogin" class="link member"><router-link :to="'/login'">ログイン</router-link></li>
        <li v-else class="link member" v-on:click="logout"><a>ログアウト</a></li>
      </ul>
    </nav>
    <nav v-if="sp" class="header_navi_agency">
      <ul class="links primary">
        <li class="menu"><a v-on:click="open" class="js-global-menu-trigger"><img src="../assets/global-menu-default.svg"></a></li>
        <li class="head">ドローンに関する全てのサービス</li>
        <li class="link">
          <router-link v-if="clogin" :to="'/login'">ログイン</router-link>
          <a v-else v-on:click="logout">ログアウト</a>
        </li>
      </ul>
    </nav>
    <div v-if="spOpen" class="global_menu">
      <nav class="header_navi_agency">
        <ul class="links primary">
          <li class="menu"><a v-on:click="open" class="js-global-menu-trigger"><img src="../assets/global-menu-active.svg"></a></li>
          <li class="head">ドローンに関する全てのサービス</li>
          <li class="link">
            <router-link v-if="clogin" :to="'/login'">ログイン</router-link>
            <a v-else v-on:click="logout">ログアウト</a>
          </li>
        </ul>
      </nav>
      <nav class="menu_list">
        <header>
          <a v-on:click="open" class="close js-global-menu-trigger"><img src="../assets/close_white.svg"></a>
          <img class="header_logo" src="../assets/menu-logo-w.svg">
          <span>が運用するサービス</span>
        </header>
        <ul>
          <li><a href="https://droneagent.jp" target="blank">ドローン専用EC</a></li>
          <li><a href="https://droneagent.jp/kusatsu/" target="blank">空撮</a></li>
          <li><a href="https://dronecamp.jp" target="blank">教習</a></li>
          <li><a href="https://droneagent.jp/flights/" target="blank">ドローンメディア</a></li>
          <li><a href="https://care.droneagent.jp/" target="blank">ケア・保守</a></li>
          <li><a href="https://droneagent.jp/law/" target="blank">許可申請代行</a></li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: [
    'login'
  ],
  data () {
    return {
      clogin: !this.login,
      pc: false,
      sp: false,
      spOpen: false
    }
  },
  watch: {
    login: function () {
      this.clogin = !this.login
    }
  },
  mounted () {
    if (window.matchMedia('(max-width: 840px)').matches) {
      this.sp = true
    } else {
      this.pc = true
    }
  },
  methods: {
    logout () {
      this.$emit('updateLogin', false)
      this.$router.push("/logout")
    },
    open () {
      this.spOpen = !this.spOpen
    }
  }
}
</script>

<style scoped>
  @import '../assets/css/header.css'
</style>



// WEBPACK FOOTER //
// src/components/Header.vue